export default __webpack_public_path__ + "static/media/scoreImage.777da286.png";